import Pending from './Pending';
import SignDocuments from './SignDocuments';

const Allium = {
  Pending,
  SignDocuments,
};

export default Allium;
